import styled from "styled-components";
import { FlexTypeProps } from "./types";

export const StyledFlex = styled.div<FlexTypeProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction || "row"};
  height: ${({ height }) => height || "auto"};
  width: ${({ width }) => width || "auto"};
  gap: ${({ gap }) => gap || "0"};
  justify-content: ${({ justifycontent }) => justifycontent || "flex-start"};
  align-items: ${({ alignitems }) => alignitems || "stretch"};
`;
